var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28558 20.3347V17.4298C9.28558 16.6883 9.88943 16.0872 10.6343 16.0872H13.3572C13.7149 16.0872 14.058 16.2286 14.3109 16.4804C14.5638 16.7322 14.7059 17.0737 14.7059 17.4298V20.3347C14.7037 20.643 14.8251 20.9394 15.0433 21.1582C15.2615 21.377 15.5584 21.5 15.868 21.5H17.7257C18.5933 21.5022 19.4262 21.1607 20.0405 20.5508C20.6548 19.9408 21 19.1126 21 18.2489V9.97352C21 9.27584 20.6893 8.61405 20.1517 8.16644L13.8322 3.14208C12.7329 2.26113 11.1579 2.28958 10.0914 3.20963L3.91612 8.16644C3.35312 8.60085 3.01663 9.2646 3 9.97352V18.2405C3 20.0407 4.46594 21.5 6.27427 21.5H8.08954C8.73274 21.5 9.25547 20.9834 9.26013 20.3431L9.28558 20.3347Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.43ee40616bdb71cadafee255dd6f2bdd.svg";
export { ForwardRef as ReactComponent };